import { KeyboardEvent, ReactNode } from "react";
import { cx } from "utils";

// Ignores keydowns bubbled from inner controls (checkboxes, menus) so they keep their own behaviour
const rowKeyDownHandler = (onClick: () => void) => (e: KeyboardEvent<HTMLTableRowElement>) => {
  if (e.target !== e.currentTarget) return;
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    onClick();
  }
};

/**
 * A body <tr>. Hoverable, clickable and keyboard-activatable when `onClick` is given.
 * No role="button": it would override the row role and nest the cells' controls in it.
 */
export const TableRow = ({
  children,
  onClick,
  className,
  ariaExpanded,
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  /** Set on expandable rows so the open/closed state is announced. */
  ariaExpanded?: boolean;
}) => (
  <tr
    className={cx(
      onClick &&
        // Outline not ring: box-shadow is unreliable on <tr> with border-collapse
        "hover:bg-gray-50 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-rebrandPurple-500",
      className
    )}
    onClick={onClick}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={onClick ? rowKeyDownHandler(onClick) : undefined}
    aria-expanded={ariaExpanded}
  >
    {children}
  </tr>
);

export default TableRow;
